import {
  ButtonWrap,
  Content,
  MediaLogo,
  MediaWrap,
  SubTitleWrap,
  TextWrap,
  Image,
} from '@/components/organisms/mediaSelect/MediaSelect.styled';
import { useState } from 'react';
import { TELECOM } from '@/const';
import { useCommonParams } from '@/hooks';
import { Button, Subtitle8, Title1, Title4 } from '@/components/atoms';
import { useRouter } from 'next/router';

interface IProps {
  setModalOpen: (value: boolean) => void;
}

const MediaSelect = ({ setModalOpen }: IProps) => {
  const router = useRouter();
  let telecomList = [...TELECOM];
  const { media: telecom } = useCommonParams();
  const [activeTelecom, setActiveTelecom] = useState(telecom);

  const nowTelecomIndex = telecomList.indexOf(telecom);
  if (nowTelecomIndex !== -1) {
    telecomList.splice(nowTelecomIndex, 1);
    telecomList = [telecom, ...telecomList];
  }

  const handleClickMedia = (telecom: string) => {
    setActiveTelecom(telecom);
  };

  const handleClickButton = async () => {
    setModalOpen(false);
    const path = router.asPath;
    if (path === '/') {
      await router.push(`/${activeTelecom}`).catch((err) => console.log(err));
    } else {
      const newPath = path.replace(telecom, activeTelecom);
      await router.replace(newPath).catch((err) => console.log(err));
    }
  };

  return (
    <Content>
      <TextWrap>
        <Title1>이용 중이신 통신사를 선택해 주세요.</Title1>
        <Title4 color="gray-40">정확한 통신사를 선택해야 혜택을 받을 수 있어요.</Title4>
      </TextWrap>
      <MediaWrap>
        {telecomList.map((telecom: string, index: number) => (
          <MediaLogo
            isActive={telecom === activeTelecom}
            key={telecom}
            onClick={() => handleClickMedia(telecom)}
          >
            <Image src={`/logo_${telecom}.svg`} alt={telecom} loading="lazy" />
          </MediaLogo>
        ))}
      </MediaWrap>
      {activeTelecom === 'skt' ? (
        <SubTitleWrap>
          <Subtitle8 color="gray-50">SKT 알뜰폰 사용자는 혜택 수신에 제한이 있습니다.</Subtitle8>
        </SubTitleWrap>
      ) : (
        <></>
      )}
      <ButtonWrap>
        <Button full size="lg" onClick={handleClickButton}>
          확인
        </Button>
      </ButtonWrap>
    </Content>
  );
};
export default MediaSelect;
